import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import { AppConfig } from '../../../config';

@Injectable()
export class PredavaciPopisService {

  constructor(private _http: Http) { }

  noviPredavac(predavac: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'predavac_spremi/', predavac)    
    .map(res => res.json()); 
  }

  dohvatiPredavace(vrstaKorisnika: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'dohvati_sve_predavace/', vrstaKorisnika)    
    .map(res => res.json()); 
  }

  urediPredavaca(polaznikPodaci: any){
    return this._http.put(AppConfig.apiAdresaSQL + 'uredi_predavaca/', polaznikPodaci)    
    .map(res => res.json()); 
  }

  uploadPredavac(polaznikPodaci: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'upload_slike_za_predavaca/', polaznikPodaci)    
    .map(res => res.json()); 
  }

  brisanje_slike_za_predavaca(polaznikPodaci: any){
    return this._http.post(AppConfig.apiAdresaSQL + 'brisanje_slike_za_predavaca/', polaznikPodaci)    
    .map(res => res.json()); 
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/virtualna-ucionica/predavaci-popis/predavaci-popis.service.ts